import { USERS_CURRENT_PROVIDER_COOKIE_FOR_ENV } from '@ruminati/utils/cookies'

import { getEnvFromUrl } from './env'

export function getCookies(): Record<string, any> {
  if (!document.cookie) return {}
  return document.cookie.split(';').reduce((acc, c) => {
    const kv = c.trim().split('=')
    return {
      ...acc,
      [kv[0]]: kv[1],
    }
  }, {})
}

export function setCookie(name: string, value: string) {
  document.cookie = `${name}=${value};path=/;${getDomainForCookie()}`
}

export function clearCookie(name: string) {
  return (document.cookie = `${name}="";expires=-1;${getDomainForCookie()}`)
}

function getDomainForCookie(): string {
  const env = getEnvFromUrl()
  if (env === 'local') return ''

  return 'domain=.ruminati.com.au'
}

export function getCurrentProviderCookie(): string | undefined {
  const cookieEnv = getEnvFromUrl()
  const CURRENT_PROVIDER_COOKIE_KEY = USERS_CURRENT_PROVIDER_COOKIE_FOR_ENV(cookieEnv)
  const cookies = getCookies()
  return cookies[CURRENT_PROVIDER_COOKIE_KEY]
}
